import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useVerifySessionAuth0 from '../../Hooks/useVerifySessionAuth0';
import useLoginAuth0Handler from '../../Hooks/useLoginAuth0Handler';
import { useStore } from '../../Store/storeProvider';
import { useAuth0 } from '@auth0/auth0-react';
import getSegmentAndGaFromCookies from '../../Helpers/getSegmendAndGaFromCookies';
import * as storage from '../../Helpers/Auth0StorageManager';
import { GetOriginId } from '../../Helpers/Origin';

const Auth0Register = () => {
    const [loginAuth0Handler] = useLoginAuth0Handler();
    const { Config } = useStore();
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const { segment, ga } = getSegmentAndGaFromCookies();

    const registerHandler = async (isVerified) => {
        storage.setSitioId(Config.SitioId);
        storage.setModo(Config.Modo);
        if (isAuthenticated) {
            if (isVerified) {
                await loginAuth0Handler();
            } else if (isVerified === false) {
                window.location = `${window.location.origin}/auth0-emailConfirmation`
            }
        }
        else {
            storage.setCallbackResetPassword(Config.URLCallback);
            const origenId = GetOriginId(Config.SitioId, Config.URLCallback);
            loginWithRedirect({
                callbackURL: `${window.btoa(Config.URLCallback)}`,
                modo: `${Config.Modo}`,
                origen: origenId,
                "ext-origen": `${origenId}`,
                prompt: 'login',
                redirectUri: `${window.location.origin}/auth0-callback/?callback=${window.btoa(Config.URLCallback)}`,
                screen_hint: 'signup',
                segment: segment,
                ga: ga
            });
        }
    }
    const [isLoadingProcess] = useVerifySessionAuth0(registerHandler);

    return (
        <div className='callback-view containerSpinner'>
            <LoadingSpinner isLoading={isLoadingProcess}>
            </LoadingSpinner>
        </div>
    );
}

export default Auth0Register;